import { Box, Button, Card, Chip, Stack, Typography } from '@mui/material'
import DiscountIcon from '@mui/icons-material/Discount'
import { motion } from 'framer-motion'

export const DiscountCard = ({ coupon, onCopy }) => {
  const daysLeft = coupon.expiresAt 
    ? Math.ceil((new Date(coupon.expiresAt) - new Date()) / (1000 * 60 * 60 * 24))
    : null

  const isExpired = daysLeft !== null && daysLeft < 0

  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      transition={{ type: 'spring', stiffness: 300 }}
    >
      <Card
        sx={{
          p: 3,
          height: '100%',
          backgroundColor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          border: isExpired ? '2px solid #ccc' : 'none',
          opacity: isExpired ? 0.6 : 1
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: -10,
            right: -10,
            width: 100,
            height: 100,
            backgroundColor: 'rgba(255,255,255,0.1)',
            borderRadius: '50%'
          }}
        />
        
        <Stack spacing={2} position="relative" zIndex={1}>
          {/* Discount Badge */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <DiscountIcon sx={{ fontSize: '2rem' }} />
              <Typography variant="h4" sx={{ fontWeight: 700 }}>
                {coupon.discountPercentage}%
              </Typography>
            </Box>
            {isExpired && (
              <Chip label="Expired" size="small" sx={{ backgroundColor: 'rgba(255,255,255,0.3)' }} />
            )}
          </Box>

          {/* Coupon Code */}
          <Box>
            <Typography variant="caption" sx={{ opacity: 0.8 }}>
              Coupon Code
            </Typography>
            <Typography 
              variant="h6" 
              sx={{ 
                fontFamily: 'monospace', 
                fontWeight: 700,
                letterSpacing: 1
              }}
            >
              {coupon.code}
            </Typography>
          </Box>

          {/* Expiry Info */}
          {coupon.expiresAt && (
            <Box>
              <Typography variant="caption" sx={{ opacity: 0.8 }}>
                {isExpired ? 'Expired' : 'Valid for'}
              </Typography>
              <Typography variant="body2">
                {isExpired ? 'This coupon has expired' : `${daysLeft} days left`}
              </Typography>
            </Box>
          )}

          {/* Usage Info */}
          {coupon.usageLimit > 0 && (
            <Typography variant="caption" sx={{ opacity: 0.8 }}>
              {coupon.usageLimit - coupon.usageCount} uses remaining
            </Typography>
          )}

          {/* Copy Button */}
          {!isExpired && (
            <Button
              variant="contained"
              sx={{
                backgroundColor: 'white',
                color: '#667eea',
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: '#f5f5f5'
                },
                mt: 1
              }}
              onClick={() => onCopy(coupon.code)}
            >
              Copy Code
            </Button>
          )}
        </Stack>
      </Card>
    </motion.div>
  )
}
